import { useEffect, useRef } from 'react';

export const useClickOutside = <T extends HTMLElement>(
  onClickAway: (event: MouseEvent | TouchEvent) => void,
  isOpen: boolean
) => {
  const ref = useRef<T | null>(null);

  const handleClickOutside = (event: MouseEvent | TouchEvent) => {
    if (ref?.current && !ref.current.contains(event.target as Node) && isOpen) {
      onClickAway(event);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignore
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside, { capture: true });
      document.addEventListener('touchstart', handleClickOutside, { capture: true });
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, { capture: true });
      document.removeEventListener('touchstart', handleClickOutside, { capture: true });
    };
  }, [isOpen]);

  return ref;
};

export default useClickOutside;
